import { toCapitalize } from 'src/react-app/utilits/toCapitalize'
import { isValidOrderByManager } from '../lib/isValidOrderByManager'
import {
  IOrderByUnitItem,
  IOrdersByManager,
  IOrdersByManagerMonth,
  IOrdersForUnitByMonth,
  OrderByUnitItem,
  OrderItemResponse,
  OrdersForUnit,
} from '../types/types'
import dayjs from 'dayjs'
import { isValidMeasurements } from '../lib/isValidMeasurements'
import { isValidCOLid } from '../lib/isValidCOLid'
import { manyTablesData } from './getTableData'
import { isValidContracts } from '../lib/isValidContracts'

const getMYKey = (src: string) => {
  const date = new Date(src)
  const month = date.toLocaleString('ru-RU', { month: 'long', timeZone: 'UTC' })
  const year = date.getFullYear().toString()

  return `${toCapitalize(month)} ${year}`
}
/**
 * Отбирает из ответа валидные для менеджеров заказы
 */
export const pickManagerOrders = (
  orders: OrderItemResponse[],
  selectedMonths: string[],
  selectedYears: string[],
) => {
  const ordersByManagerTmp = new Map() as IOrdersByManager
  orders
    .filter(el => isValidOrderByManager(el, selectedMonths, selectedYears))
    .forEach((rawOrder, i, array) => {
      // Эти поля валидируются в isValidOrderByManager
      const orderItem = rawOrder as {
        'case-date-fact': string
        'stage-code': string
        'contract-sum': number
        'production-order-number': string
        prepayment_date: string
        'manager-name': string
        'manager-id': string
        office: string
      }
      const MYKey = getMYKey(orderItem['prepayment_date'])
      const managerName = orderItem['manager-name']
      const officeName = orderItem['office']
      const managerId = orderItem['manager-id']

      const order: IOrderByUnitItem = {
        rowIndex: i,
        orderDate: orderItem['prepayment_date'] as string,
        caseDate: orderItem['case-date-fact'],
        contractNum: orderItem?.['order-contract-number'] || 'Не указан',
        productionNum: orderItem?.['production-order-number'] || 'Не указан',
        sum: orderItem['contract-sum'] as number,
        manager: managerName,
        managerId: managerId,
        office: officeName,
        clientName: orderItem['client-name'],
        days: orderItem['prepayment_date']
          ? dayjs(orderItem['prepayment_date']).diff(orderItem['case-date-fact'], 'day') || 1
          : 1,
        key: orderItem['order-date-fact'],
      }

      if (!ordersByManagerTmp.has(MYKey)) {
        ordersByManagerTmp.set(MYKey, { orders: [], total: 0 })
      }
      const res = ordersByManagerTmp.get(MYKey) as IOrdersByManagerMonth
      res.orders.push(order)
      res.total += order.sum
    })
  return ordersByManagerTmp
}
/**
 * Отбирает из ответа валидные заказы и разбивает по месяцам
 */
export const pickMonthOrders = (
  orders: OrderItemResponse[],
  selectedMonths: string[],
  selectedYears: string[],
  showOffices: boolean,
) => {
  const ordersPerManager = {} as IOrdersForUnitByMonth
  const ordersPerOffice = {} as IOrdersForUnitByMonth
  const monthKeys = new Set<string>()
  /** уникальные ID заказов, у которых Дата заявки находится в пределах выбранного периода,
   * если  Причина закрытия заказа не равно Нецелевое обращение)*/
  const unIdsCO = new Set()

  const checkOrdersFields = (month: string, unit: string, targetObj: IOrdersForUnitByMonth) => {
    if (!targetObj[month]) {
      targetObj[month] = {}
    }
    if (!targetObj[month][unit]) {
      targetObj[month][unit] = new OrdersForUnit()
    }
    return targetObj[month][unit]
  }
  orders
    // .filter(
    //   el =>
    //     //Если [Дата создания обращения] или [Дата замера] во врем. промежутке
    //     el['prepayment_date']
    // )
    .forEach((orderItem: OrderItemResponse) => {
      const managerName = orderItem['manager-name'] as string
      const managerId = orderItem['manager-id'] as string
      const officeName = orderItem['office'] as string

      if (isValidContracts(orderItem, selectedMonths, selectedYears)) {
        const MYKey = getMYKey(orderItem['prepayment_date']!) // 'prepayment_date' валидируется в isValidContracts
        if (!monthKeys.has(MYKey)) {
          monthKeys.add(MYKey)
        }
        const managerStat = checkOrdersFields(MYKey, managerId, ordersPerManager)
        if (!managerStat.managerName) managerStat.managerName = managerName

        if (showOffices) {
          if (!managerStat.officeName) managerStat.officeName = officeName
          checkOrdersFields(MYKey, officeName, ordersPerOffice)
        }

        ordersPerManager[MYKey][managerId].PayedOrders.push(orderItem)
        if (showOffices) ordersPerOffice[MYKey][officeName].PayedOrders.push(orderItem)
      }

      if (
        isValidMeasurements(orderItem, selectedMonths, selectedYears) /*&& item["prepayment_date"]*/
      ) {
        const measurementMYKey = getMYKey(orderItem['measurement-date-fact'])
        const managerStat = checkOrdersFields(measurementMYKey, managerId, ordersPerManager)
        if (!managerStat.managerName) managerStat.managerName = managerName

        ordersPerManager[measurementMYKey][managerId].Measurements += 1
        if (showOffices) {
          if (!managerStat.officeName) managerStat.officeName = officeName
          checkOrdersFields(measurementMYKey, officeName, ordersPerOffice)
          ordersPerOffice[measurementMYKey][officeName].Measurements += 1
        }
      }
        
      if (isValidCOLid(orderItem, selectedMonths, selectedYears)) {
        const caseDateMYKey = getMYKey(orderItem['case-date-fact'])
        if (!monthKeys.has(caseDateMYKey)) {
          monthKeys.add(caseDateMYKey)
        }
        if (!unIdsCO.has(orderItem['parent-id'])) {
          const managerStat = checkOrdersFields(caseDateMYKey, managerId, ordersPerManager)
          if (!managerStat.managerName) managerStat.managerName = managerName
          ordersPerManager[caseDateMYKey][managerId].CO.push(orderItem)
          if (showOffices) {
            if (!managerStat.officeName) managerStat.officeName = officeName

            const officeStat = checkOrdersFields(caseDateMYKey, officeName, ordersPerOffice)
            if (!officeStat.officeName) officeStat.officeName = officeName
            ordersPerOffice[caseDateMYKey][officeName].CO.push(orderItem)
          }
          unIdsCO.add(orderItem['parent-id'])
        }
      }
    })
  return manyTablesData(
    ordersPerManager,
    showOffices ? ordersPerOffice : undefined,
    monthKeys,
    selectedMonths,
    selectedYears,
    showOffices,
  )
}
